import { Pass } from "three/examples/jsm/postprocessing/Pass";

// Renders the background plate scene first (full clear), then the main
// scene on top with only a depth clear in between (no color clear) — this
// is what puts the plate behind everything with no depth-testing
// relationship to the main scene's own objects, matching the reference's
// two-scene/two-camera compositing exactly. A plain RenderPass can only
// render one scene/camera pair, so this replaces it as the composer's first
// pass.
export class TwoScenePass extends Pass {
  constructor(bgScene, bgCamera, scene, camera, debug) {
    super();

    this.bgScene = bgScene;
    this.bgCamera = bgCamera;
    this.scene = scene;
    this.camera = camera;
    // Optional Debug instance — splits the plate render from the main-scene
    // render so we can tell which one actually owns the cost, instead of
    // one bundled "twoScene" figure. Undefined/no-op in production.
    this.debug = debug;

    this.needsSwap = false;
  }

  render(renderer, writeBuffer, readBuffer) {
    const oldAutoClear = renderer.autoClear;
    renderer.autoClear = false;

    renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
    renderer.clear();

    this.debug?.begin("render:plate");
    renderer.render(this.bgScene, this.bgCamera);
    this.debug?.end("render:plate");

    renderer.clearDepth();

    this.debug?.begin("render:mainScene");
    renderer.render(this.scene, this.camera);
    this.debug?.end("render:mainScene");

    renderer.autoClear = oldAutoClear;
  }
}
